// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_jlpt_levels_n4_title = /** @type {(inputs: {}) => string} */ () => {
	return `N4 – Elementary`
};

const id_jlpt_levels_n4_title = /** @type {(inputs: {}) => string} */ () => {
	return `N4 – Dasar`
};

const ja_jlpt_levels_n4_title = /** @type {(inputs: {}) => string} */ () => {
	return `N4 – 初級`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "id" | "ja" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const jlpt_levels_n4_title = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.jlpt_levels_n4_title(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("jlpt_levels_n4_title", locale)
	if (locale === "en") return en_jlpt_levels_n4_title(inputs)
	if (locale === "id") return id_jlpt_levels_n4_title(inputs)
	return ja_jlpt_levels_n4_title(inputs)
};
export { jlpt_levels_n4_title as "jlpt_levels.n4.title" }